import HeaderMenu from './HeaderMenu'

export default function HeaderDesktop() {
  return (
    <ul className="hidden w-full lg:items-center lg:justify-end lg:flex gap-16 xl:gap-24">
      <HeaderMenu />
    </ul>
  )
}
